// extracted by mini-css-extract-plugin
export var contentBody = "_60-9";
export var headerImage = "_60-2";
export var imageButton = "_60-7";
export var imageButtonIcon = "_60-8";
export var imageHeader = "_60-4";
export var imageHeaderText = "_60-5";
export var imageOverlay = "_60-3";
export var imageTitle = "_60-6";
export var imageWrapper = "_60-1";
export var taskList = "_60-a";
export var widget = "_60-0";